import type { BlockExport } from "@circle-react-shared/BuilderUI/BuilderUI.types";
import { HomepageBlock7 as Block } from "./HomepageBlock7";
import { defaultData } from "./HomepageBlock7DefaultData";
import { meta } from "./HomepageBlock7MetaData";
import imagePreview from "./homepage_block_7_preview.png";

export const HomepageBlock7: BlockExport = {
  type: "component",
  Block,
  imagePreview: {
    type: "image-url",
    lg: imagePreview,
  },
  defaultData,
  meta,
};
